/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { NetCDFFileTypeEnum } from "./NetCDFFileTypeEnum";
import {
  NetCDFFileTypeEnumFromJSON,
  NetCDFFileTypeEnumFromJSONTyped,
  NetCDFFileTypeEnumToJSON,
  NetCDFFileTypeEnumToJSONTyped,
} from "./NetCDFFileTypeEnum";
import type { TimeseriesRainMmUnitsEnum } from "./TimeseriesRainMmUnitsEnum";
import {
  TimeseriesRainMmUnitsEnumFromJSON,
  TimeseriesRainMmUnitsEnumFromJSONTyped,
  TimeseriesRainMmUnitsEnumToJSON,
  TimeseriesRainMmUnitsEnumToJSONTyped,
} from "./TimeseriesRainMmUnitsEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface FileTimeseriesRain
 */
export interface FileTimeseriesRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number | null;
  /**
   * Duration of event in seconds
   */
  duration?: number | null;
  /**
   * in simulation in seconds
   */
  timestamps?: Array<number> | null;
  /**
   * interval in seconds
   */
  interval?: number | null;
  /**
   *
   */
  valuesReference?: string | null;
  /**
   *
   */
  fillValue?: string;
  /**
   *
   */
  readonly type?: NetCDFFileTypeEnum;
  /**
   *
   */
  units: TimeseriesRainMmUnitsEnum;
  /**
   *
   */
  file?: FileReadOnly;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the FileTimeseriesRain interface.
 */
export function instanceOfFileTimeseriesRain(value: object): value is FileTimeseriesRain {
  if (!("units" in value) || value["units"] === undefined) return false;
  return true;
}

export function FileTimeseriesRainFromJSON(json: any): FileTimeseriesRain {
  return FileTimeseriesRainFromJSONTyped(json, false);
}

export function FileTimeseriesRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FileTimeseriesRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    timestamps:
      json["timestamps"] === undefined
        ? undefined
        : json["timestamps"] === null
        ? null
        : json["timestamps"],
    interval:
      json["interval"] === undefined
        ? undefined
        : json["interval"] === null
        ? null
        : json["interval"],
    valuesReference:
      json["values_reference"] === undefined
        ? undefined
        : json["values_reference"] === null
        ? null
        : json["values_reference"],
    fillValue: json["fill_value"] == null ? undefined : json["fill_value"],
    type: json["type"] == null ? undefined : NetCDFFileTypeEnumFromJSON(json["type"]),
    units: TimeseriesRainMmUnitsEnumFromJSON(json["units"]),
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function FileTimeseriesRainToJSON(json: any): FileTimeseriesRain {
  return FileTimeseriesRainToJSONTyped(json, false);
}

export function FileTimeseriesRainToJSONTyped(
  value?: Omit<FileTimeseriesRain, "url" | "simulation" | "type" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    multiplier: value["multiplier"],
    offset: value["offset"],
    duration: value["duration"],
    timestamps: value["timestamps"],
    interval: value["interval"],
    values_reference: value["valuesReference"],
    fill_value: value["fillValue"],
    units: TimeseriesRainMmUnitsEnumToJSON(value["units"]),
    file: FileReadOnlyToJSON(value["file"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
